<template>
  <svg
    ref="svg"
    :width="size"
    :height="size"
    :viewPort="`0 0 ${size} ${size}`"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    :class="{ reverse: reverse }"
  >
    <circle
      :r="radius - stroke / 2"
      :cx="radius"
      :cy="radius"
      fill="transparent"
      :stroke-width="stroke"
      :stroke-dasharray="perimeter"
      stroke-dashoffset="0"
      :stroke-opacity="backgroundOpacity"
      class="background"
    ></circle>
    <circle
      ref="bar"
      class="bar"
      :r="radius - stroke / 2"
      :cx="radius"
      :cy="radius"
      fill="transparent"
      :stroke-dasharray="perimeter"
      :stroke-width="stroke"
      stroke-dashoffset="0"
      :style="styleRadius"
      :stroke-opacity="opacity"
    ></circle>
    <line
      v-if="clock"
      class="line"
      :x1="radius - stroke / 2"
      :y1="radius"
      :x2="1.5 * radius"
      :y2="radius"
      :stroke-width="stroke * 0.5"
    />
    <line
      v-if="clock"
      :style="styleLine"
      class="line line-on"
      :x1="radius - stroke / 2"
      :y1="radius"
      :x2="1.6 * radius"
      :y2="radius"
      :stroke-width="stroke * 0.5"
    />
  </svg>
</template>
<script setup lang="ts">
interface Props {
  size?: number;
  stroke?: number;
  backgroundColor?: string;
  backgroundOpacity?: number;
  color?: string;
  opacity?: number;
  progress: number;
  reverse?: boolean;
  clock?: boolean;
}
const props = defineProps({
  size: { default: 10 },
  stroke: { default: 3 },
  backgroundColor: { default: '#e9e9e9' },
  backgroundOpacity: { default: 1 },
  color: { default: '#6048fd' },
  opacity: { default: 1 },
  progress: null,
  reverse: { type: Boolean, default: false },
  clock: { type: Boolean, default: false }
});
const bar = ref(null);
const radius = computed(() => props.size / 2);
const perimeter = computed(() => Math.PI * (props.size - props.stroke));
const offset = computed(() => {
  return (1 - props.progress) * perimeter.value;
});

const styleRadius = computed(() => {
  return {
    strokeDashoffset: offset.value,
  };
});

const styleLine = computed(() => {
  return {
    transform: `rotate(${-90 + props.progress * 360}deg)`,
  };
});

const bgcolor = computed(() => props.backgroundColor);
</script>
<style lang="scss" scoped>
svg {
  &.reverse {
    transform: scaleX(-1);
    transform-origin: center;
  }
  line,
  circle {
    transform: rotate(-90deg);
    transform-origin: 50%;
  }
  circle {
    transition: stroke-dashoffset 1s linear;
    stroke-dashoffset: 0;
  }
}

.bar,
.line {
  stroke: v-bind(color);
  .reverse & {
    stroke: v-bind(bgcolor);
  }
}
.background {
  stroke: v-bind(bgcolor);
  .reverse & {
    stroke: v-bind(color);
  }
}
</style>
